"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicationService = void 0;
const simplePropertyObjectType = 'SkodaAuto.Marvin.K2Tools.Common.Contracts.Public.SimplePropertyObject, SkodaAuto.K2NGTools.Core.Contracts';
const arrayPropertyObjectType = 'SkodaAuto.Marvin.K2Tools.Common.Contracts.Public.ArrayPropertyObject, SkodaAuto.K2NGTools.Core.Contracts';
const navigationPropertyObjectType = 'SkodaAuto.Marvin.K2Tools.Common.Contracts.Public.NavigationPropertyObject, SkodaAuto.K2NGTools.Core.Contracts';
class PublicationService {
}
exports.PublicationService = PublicationService;
PublicationService.getExtensionValueBoolean = (extension, ...navigation) => {
    const value = PublicationService.getExtensionValue(extension, ...navigation);
    return value ? value === 'True' : undefined;
};
PublicationService.getExtensionValueFloat = (extension, ...navigation) => {
    const value = PublicationService.getExtensionValue(extension, ...navigation);
    return value ? Number.parseFloat(value) : undefined;
};
PublicationService.getExtensionValueInt = (extension, ...navigation) => {
    const value = PublicationService.getExtensionValue(extension, ...navigation);
    return value ? Number.parseInt(value) : undefined;
};
PublicationService.getExtensionValue = (extension, ...navigation) => {
    var _a;
    const foundProperty = navigation.reduce((prev, curr, index) => index === 0 ? prev : PublicationService.findInPropertyObject(prev, curr), (_a = extension === null || extension === void 0 ? void 0 : extension.properties) === null || _a === void 0 ? void 0 : _a.find(prop => navigation[0] === prop.code));
    return foundProperty && foundProperty.$type === simplePropertyObjectType
        ? foundProperty.value
        : undefined;
};
PublicationService.getExtensionValueWithCulture = (extension, culture, ...navigation) => {
    var _a;
    const foundProperty = navigation.reduce((prev, curr, index) => index === 0 ? prev : PublicationService.findInPropertyObject(prev, curr, culture), (_a = extension === null || extension === void 0 ? void 0 : extension.properties) === null || _a === void 0 ? void 0 : _a.find(prop => navigation[0] === prop.code));
    return foundProperty && foundProperty.$type === simplePropertyObjectType
        ? foundProperty.value
        : undefined;
};
PublicationService.findInPropertyObject = (propertyObject, code, culture = null) => {
    var _a, _b, _c, _d;
    switch (propertyObject === null || propertyObject === void 0 ? void 0 : propertyObject.$type) {
        case simplePropertyObjectType:
            return propertyObject;
        case navigationPropertyObjectType:
            return (_b = (_a = propertyObject.instance) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.find(prop => prop.code === code);
        case arrayPropertyObjectType:
            if (culture) {
                const items = (_c = propertyObject.items) === null || _c === void 0 ? void 0 : _c.filter(prop => prop.code === code);
                if (items.length > 1 && items[0].$type === navigationPropertyObjectType) {
                    const cultureItem = items === null || items === void 0 ? void 0 : items.find(item => {
                        var _a, _b;
                        return (_b = (_a = item.instance) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.find(prop => { var _a, _b; return prop.$type === simplePropertyObjectType && ((_a = prop.code) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'culture' && ((_b = prop === null || prop === void 0 ? void 0 : prop.value) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === culture.toLowerCase(); });
                    });
                    return cultureItem;
                }
            }
            return (_d = propertyObject.items) === null || _d === void 0 ? void 0 : _d.find(prop => prop.code === code);
        default:
            return null;
    }
};
